window.currentObserver = window.currentObserver || null;
window.observerCount = window.observerCount || 0;

function initInfiniteScroll() {
  const trigger = document.getElementById('infinite-scroll-trigger');
  if (!trigger) return;

  let currentPage = parseInt(trigger.dataset.currentPage, 10) || 1;
  const totalPages = parseInt(trigger.dataset.totalPages, 10) || 1;
  const productList = document.querySelector('product-list');
  let loading = false;

  function buildNextPageUrl(page) {
    const url = new URL(window.location.href);
    url.searchParams.set('page', page);
    return url.pathname + url.search;
  }

  async function loadNextPage() {
    if (loading || currentPage >= totalPages) return;
    loading = true;
    currentPage++;
    const url = buildNextPageUrl(currentPage);
    const response = await fetch(url);
    const text = await response.text();
    const doc = new DOMParser().parseFromString(text, 'text/html');
    const newList = doc.querySelector('product-list');
    if (newList) {
      Array.from(newList.children).forEach(child => {
        productList.appendChild(child);
        child.style.opacity = '1';
        child.style.transform = 'translateY(0px)';
      });
    } else {
      console.warn('No se encontró product-list en lasiguiente página');
    }
    loading = false;
  }

  window.observerCount++;
  console.log('observer creado ', window.observerCount); //verificar que solo sea un observer, si son varios estámal
  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting && currentPage < totalPages) {
      loadNextPage();
    }
  }, { rootMargin: '200px', threshold: 0.5 });

  observer.observe(trigger);
  window.currentObserver = observer;
}

initInfiniteScroll();